var headerHeight = function () {
    var events = ['load', 'resize'];
    events.forEach(function (event) {
        window.addEventListener(event, function () {
            var header = document.querySelector('.shopify-section-header');
            var headerHeight = header.offsetHeight;
            document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
        });
    });
};
export { headerHeight };
